<!-- Mobile gets the poster tile that opens out to fullscreen. -->
<ng-container *ifScreenSize="ScreenType.Mobile">
  <ng-container *ngIf="!isComingSoon; else comingSoon">
    <!-- Announcements with no description have nothing more to show, so they stay inert. -->
    <fgbcl-expandable-card
      class="announcement-card"
      [class.is-text-only]="!showHeader"
      [image]="announcement.Image | contentImage: '23'"
      [imageAlt]="announcement.Image"
      [footerTitle]="announcement.Title"
      [caption]="(announcement.ShortDescription || announcement.Description) | markdownTranslate"
      [showImage]="showHeader"
      [expandable]="isExpandable"
    >
      <!-- Video announcements keep their player in place of the still image. -->
      @if (showVideo) {
        <ng-template #headerContent>
          <fgbcl-video-player [videoId]="announcement.VideoId" position="bottom-left"></fgbcl-video-player>
        </ng-template>
      }

      <!-- The strip's copy of the title fades out as this opens, so it is the heading in fullscreen. -->
      <ng-template #expandedContent>
        <h3 class="announcements-title">{{ announcement.Title }}</h3>
        <div class="announcements-info" [innerHTML]="announcement.Description | safeHtml"></div>
        <ng-container *ngTemplateOutlet="link"></ng-container>
      </ng-template>
    </fgbcl-expandable-card>
  </ng-container>
</ng-container>

<!-- Desktop keeps the original side by side layout. -->
<ng-container *ifScreenSize="ScreenType.Desktop">
  <div class="announcements-container row w-100 overflow-hidden border">
    <ng-container *ngIf="!isComingSoon; else comingSoon">
      <ng-container *ngTemplateOutlet="default"></ng-container>
    </ng-container>
  </div>
</ng-container>

<ng-template #default>
  <!-- Text only announcements drop the media column and let the text take the full width. -->
  <ng-container *ngIf="showHeader && announcement.Image">
    <div class="col-lg-6">
      <!-- Video Player -->
      @if (showVideo) {
        <fgbcl-video-player [videoId]="announcement.VideoId" position="bottom-left"></fgbcl-video-player>
      } @else {
        <img class="announcement-image" src="{{ announcement.Image | contentImage: '23' }}" alt="{{ announcement.Image }}" />
      }
    </div>
  </ng-container>

  <div class="announcements-text text-start position-relative" [class.col-lg-6]="showHeader && announcement.Image">
    <h3 class="announcements-title">{{ announcement.Title }}</h3>
    <div class="announcements-info" [innerHTML]="announcement.Description | safeHtml"></div>
    <ng-container *ngTemplateOutlet="link"></ng-container>
  </div>
</ng-template>

<ng-template #comingSoon>
  <div class="announcements-container row w-100 overflow-hidden border">
    <div class="col-lg-6 bg-announcements announcement-coming-soon">
      <label>{{ 'announcement.coming.soon.time.left' | translate }}</label>
      <fgbcl-countdown-v2
        [startDateTime]="announcement.RequestTime"
        [endDateTime]="announcement.StartDate"
        (complete)="isComingSoon = false"
      ></fgbcl-countdown-v2>
    </div>
    <div class="col-lg-6 announcements-text text-start position-relative">
      <h3 class="announcements-title">{{ announcement.ComingSoonTitle }}</h3>
      <div class="announcements-info" [innerHTML]="announcement.ComingSoonDescription | safeHtml"></div>
      <ng-container *ngTemplateOutlet="link"></ng-container>
    </div>
  </div>
</ng-template>

<ng-template #link>
  <ng-container *ngIf="announcement.LinkUrl">
    <a class="announcement-link" *ngIf="announcement.LinkType == 1" [routerLink]="announcement.LinkUrl">
      {{ announcement.LinkTitle }}
    </a>
    <a
      class="announcement-link"
      *ngIf="announcement.LinkType == 2"
      [href]="announcement.LinkUrl"
      [target]="isEnableTarget ? '_blank' : ''"
    >
      {{ announcement.LinkTitle }}
    </a>
  </ng-container>
</ng-template>
